import { createActions, createReducer } from 'reduxsauce'
import DestaqueService from '_/servicos/DestaqueService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDestaqueInicio: [],
    buscaDestaqueSucesso: ['destaque'],
    buscaDestaqueErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDestaque = () => {
    return dispatch => {
        dispatch(Creators.buscaDestaqueInicio())

        let serv = new DestaqueService()

        return serv
            .getInformacoes()
            .then(response => dispatch(Creators.buscaDestaqueSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDestaqueErro(error)))
    }
}

const buscaDestaqueInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDestaqueSucesso = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDestaqueErro = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.destaque, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DESTAQUE_INICIO]: buscaDestaqueInicio,
    [Types.BUSCA_DESTAQUE_ERRO]: buscaDestaqueSucesso,
    [Types.BUSCA_DESTAQUE_SUCESSO]: buscaDestaqueErro,
})
